import React, { useState } from "react";
import styles from "./Dashboard.module.css";
import BarPlotHorizontal from "./BarPlotHorizontal";
import { FaMinus, FaPlus } from "react-icons/fa";

const Dashboard = () => {
  const tables = [
    {
      name: "Category Rates",
      columns: ["Category", "Purity", "Today's Rate"],
      data: [
        { category: "Platinum", purity: "22K", rate: 11111 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Silver", purity: "999", rate: 65 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Silver", purity: "999", rate: 65 },
        { category: "Gold", purity: "22K", rate: 5250 },
        { category: "Silver", purity: "999", rate: 65 },
        { category: "Platinum", purity: "950", rate: 3200 },
      ],
    },
    {
      name: "Custom Orders",
      columns: ["Customer Name", "Product", "Status"],
      data: [
        { customer: "Jane Smith", product: "Earrings", status: "Pending" },
        { customer: "Emily Johnson", product: "Bracelet", status: "In-progress" },
        { customer: "Michael Brown", product: "Ring", status: "Completed" },
        { customer: "Sarah Connor", product: "Pendant", status: "Pending" },
        { customer: "Robert Downey", product: "Ring", status: "Pending" },
        { customer: "Tom Holland", product: "Earrings", status: "Pending" },
        { customer: "Chris Hemsworth", product: "Necklace", status: "In-progress" },
        { customer: "Mark Ruffalo", product: "Ring", status: "Pending" },
        { customer: "Jeremy Renner", product: "Bracelet", status: "Completed" },
        { customer: "Paul Rudd", product: "Pendant", status: "In-progress" },
        { customer: "Brie Larson", product: "Necklace", status: "Pending" },
        { customer: "Chadwick Boseman", product: "Ring", status: "Completed" },
        { customer: "Tom Hiddleston", product: "Bracelet", status: "In-progress" },
      ],
    },
    {
      name: "Account Summary",
      columns: ["Section", "Weights", "Amount"],
      data: [
        { section: "Savings", weights: "2kg", amount: "₹ 5000" },
        { section: "Investments", weights: "5kg", amount: "₹ 12000" },
        { section: "Gold Bond", weights: "1.5kg", amount: "₹ 3000" },
      ],
    },
    {
      name: "Sample In",
      columns: ["Name", "Weight", "Date"],
      data: [
        { name: "Sample A", weight: "100g", date: "2024-12-01" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample B", weight: "200g", date: "2024-12-02" },
        { name: "Sample C", weight: "300g", date: "2024-12-03" },
        { name: "Sample C", weight: "300g", date: "2024-12-03" },
      ],
    },
    {
      name: "Sample Out",
      columns: ["Name", "Weight", "Date"],
      data: [
        { name: "Sample X", weight: "150g", date: "2024-12-04" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Y", weight: "250g", date: "2024-12-05" },
        { name: "Sample Z", weight: "350g", date: "2024-12-06" },
      ],
    },
    {
      name: "Customer Balance",
      columns: ["Name", "Fine Gold", "Amount"],
      data: [
        { name: "Alice", fineGold: "10g", amount: " ₹600" },
        { name: "Bob", fineGold: "20g", amount: "₹ 1200" },
        { name: "Charlie", fineGold: "15g", amount: "₹ 900" },
        { name: "Alice", fineGold: "10g", amount: " ₹600" },
        { name: "Charlie", fineGold: "15g", amount: "₹ 900" },
        { name: "Alice", fineGold: "10g", amount: " ₹600" },
        { name: "Bob", fineGold: "20g", amount: "₹ 1200" },
        { name: "Charlie", fineGold: "15g", amount: "₹ 900" },
        { name: "Alice", fineGold: "10g", amount: " ₹600" },
        { name: "Charlie", fineGold: "15g", amount: "₹ 900" },
        { name: "Charlie", fineGold: "15g", amount: "₹ 900" },
      ],
    },
    {
      name: "Bulk Orders",
      columns: ["Karigar Name", "Product", "Quantity"],
      data: [
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 1", product: "Bangles", quantity: 10 },
        { karigar: "Karigar 2", product: "Chains", quantity: 5 },
        { karigar: "Karigar 3", product: "Earrings", quantity: 20 },
      ],
    },
    {
      name: "Pending Deliveries",
      columns: ["Name", "Product", "Delivery Date"],
      data: [
        { name: "David", product: "Ring", deliveryDate: "2024-12-15" },
        { name: "David", product: "Ring", deliveryDate: "2024-12-15" },
        { name: "Sophia", product: "Necklace", deliveryDate: "2024-12-18" },
        { name: "David", product: "Ring", deliveryDate: "2024-12-15" },
        { name: "David", product: "Ring", deliveryDate: "2024-12-15" },
        { name: "Liam", product: "Bracelet", deliveryDate: "2024-12-20" },
        { name: "Sophia", product: "Necklace", deliveryDate: "2024-12-18" },
        { name: "Sophia", product: "Necklace", deliveryDate: "2024-12-18" },
        { name: "Liam", product: "Bracelet", deliveryDate: "2024-12-20" },
        { name: "Liam", product: "Bracelet", deliveryDate: "2024-12-20" },
        { name: "Liam", product: "Bracelet", deliveryDate: "2024-12-20" },
      ],
    },
    {
      name: "Pending Repairs",
      columns: ["Name", "Product", "Date"],
      data: [
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair B", product: "Earring", date: "2024-12-11" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair A", product: "Chain", date: "2024-12-10" },
        { name: "Repair C", product: "Ring", date: "2024-12-12" },
      ],
    },
  ];

  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (tableIndex, rowIndex) => {
    setExpandedRows((prev) => ({
      ...prev,
      [`${tableIndex}-${rowIndex}`]: !prev[`${tableIndex}-${rowIndex}`],
    }));
  };

  const sortedCustomOrders = tables.find(
    (table) => table.name === "Custom Orders"
  );

  if (sortedCustomOrders) {
    sortedCustomOrders.data.sort((a, b) => {
      const statusOrder = {
        Completed: 1,
        "In-progress": 2,
        Pending: 3,
      };
      return statusOrder[a.status] - statusOrder[b.status];
    });
  }
  return (
    <>
      <div className={styles.dashboard}>
        {tables.map((table, tableIndex) => {
          // Conditionally render the BarPlotHorizontal component for Account Summary
          if (table.name === "Account Summary") {
            return (
              <div className={styles.chartContainer} key={tableIndex}>
                <h3 style={{width: "96%"}}>{table.name}</h3>
                <BarPlotHorizontal data={table.data} />
              </div>
            );
          }

          return (
            <div className={styles.tableContainer} key={tableIndex}>
              <h3>{table.name}</h3>
              <div className={styles.tableWrapper}>
                <table style={{ position: "relative" }} className={styles.table}>
                  <thead>
                    <tr>
                      {table.columns.map((col, i) => (
                        <th style={{ position: "sticky", top: "0" }} key={i}>
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {table.data.map((row, rowIndex) => (
                      <React.Fragment key={rowIndex}>
                        <tr
                          className={`${styles.row} ${
                            expandedRows[`${tableIndex}-${rowIndex}`]
                              ? styles.activeRow
                              : ""
                          }`}
                        >
                          {Object.entries(row).map(([key, value], colIndex) => (
                            <td
                              key={colIndex}
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {key === "status" ? (
                                <span
                                  style={{
                                    color:
                                      value === "Pending"
                                        ? "red"
                                        : value === "Completed"
                                        ? "green"
                                        : value === "In-progress"
                                        ? "#e0bc00"
                                        : "black",
                                  }}
                                >
                                  {value}
                                </span>
                              ) : ["name", "customer", "karigar"].includes(
                                  key
                                ) ? (
                                <div className={styles.expandableCell}>
                                  {expandedRows[`${tableIndex}-${rowIndex}`] ? (
                                    <FaMinus
                                      size={7}
                                      style={{
                                        color: "white",
                                        backgroundColor: "#38414a",
                                        borderRadius: "50%",
                                        padding: "4px",
                                      }}
                                      onClick={() =>
                                        toggleRow(tableIndex, rowIndex)
                                      }
                                    />
                                  ) : (
                                    <FaPlus
                                      size={7}
                                      style={{
                                        color: "white",
                                        backgroundColor: "#38414a",
                                        borderRadius: "50%",
                                        padding: "4px",
                                      }}
                                      onClick={() =>
                                        toggleRow(tableIndex, rowIndex)
                                      }
                                    />
                                  )}
                                  <span className={styles.nameColumn}>
                                    {value}
                                  </span>
                                </div>
                              ) : key === "rate" ? (
                                <input
                                  type="number"
                                  defaultValue={value}
                                  className={styles.inputNumber}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      const inputs = e.target
                                        .closest("tbody")
                                        .querySelectorAll("input");
                                      const currentIndex = Array.from(
                                        inputs
                                      ).indexOf(e.target);

                                      if (e.shiftKey) {
                                        if (inputs[currentIndex - 1]) {
                                          inputs[currentIndex - 1].focus();
                                        }
                                      } else {
                                        if (inputs[currentIndex + 1]) {
                                          inputs[currentIndex + 1].focus();
                                        }
                                      }
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              ) : (
                                value
                              )}
                            </td>
                          ))}
                        </tr>
                        {expandedRows[`${tableIndex}-${rowIndex}`] && (
                          <tr className={styles.expandedRow}>
                            <td colSpan={table.columns.length}>
                              <div className={styles.expandedContent}>
                                Expanded content for{" "}
                                {row.name || row.customer || row.karigar}...
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Dashboard;